function e() {
  for (var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++) {
    n[_key] = arguments[_key];
  }
  return n.filter(Boolean).join(" ");
}
export { e as classNames };